import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import PaymentSuccess from "./PaymentSuccess";
import PaymentFailure from "./PaymentFailure";
import Loader from "../../../components/UserComponents/Loader";
import axiosInstance from "../../../utils/api/axiosInstance";
import { USER_URL } from "../../../constants";
import PaymentPending from "./PaymentPending";

const Payment = () => {
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [isCod, setIsCod] = useState(false);
  const [order, setOrder] = useState(null);
  const { orderId } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => {
    async function updateOrderStatus() {
      try {
        let queryString = "";
        const successParam = params.get("success");
        const codParam = params.get("isCod") === "true";
        if (successParam) {
          queryString = `?success=${successParam}`;
        }
        if (codParam) {
          const { data } = await axiosInstance(USER_URL + `/order/${orderId}`);
          setOrder(data?.data);
          setIsCod(params.get("isCod") === "true");
          setPaymentStatus(successParam === "true" ? "success" : "failed");
          return;
        }

        const { data } = await axiosInstance.post(
          USER_URL + `/complete-order/${orderId}?${queryString}`
        );
        setOrder(data?.data);
        if (!successParam) {
          setPaymentStatus(data?.data?.paymentStatus);
          return;
        }
        setPaymentStatus(successParam === "true" ? "success" : "failed");
      } catch (error) {
        console.log(error);
        setPaymentStatus("pending");
      }
    }
    updateOrderStatus();
  }, [params, navigate, orderId]);

  if (!paymentStatus) {
    return <Loader />;
  }
  return (
    <>
      {paymentStatus === "success" ? (
        <PaymentSuccess
          isCod={isCod}
          paymentStatus={paymentStatus}
          order={order}
        />
      ) : paymentStatus === "failed" ? (
        <PaymentFailure />
      ) : (
        <PaymentPending />
      )}
    </>
  );
};

export default Payment;
